export const getUserName = ({ firstName, lastName, middleName, type = 'full' }) => {
    switch (type) {
        case 'short': {
            const firstLetterFirstName = firstName ? `${firstName[0].toUpperCase()}.` : '';
            const firstLetterMiddleName = middleName ? `${middleName[0].toUpperCase()}.` : '';
            return `${lastName || ''} ${firstLetterFirstName}${firstLetterMiddleName}`.trim();
        }
        default:
            return `${lastName || ''} ${firstName || ''} ${middleName || ''}`.trim();
    }
};
